<template>
  <div id="solution">
    <div class="banner">
      <BannerDetail src="https://website.obs.icheer.cn/icheer-web/images/solution/banner-character.jpg"/>
      <div class="mask"></div>
      <div class="title1">
        <div class="div1">THE</div>
        <div class="div2" style="margin-top: 25px">SOLUTION</div>
        <div class="div3">
          <hr class="banner-title-hr"/>
        </div>
        <div class="div4">解决方案</div>
      </div>
    </div>
    <div class="main">
        <div class="normal">
          <el-row class="menu" >
            <el-col :span="6" @click="tabClick('bluetooth')">
              <div  :class="activeKey==='bluetooth'?'activeStyle':''">蓝牙方案</div>
            </el-col>
            <el-col :span="6" @click="tabClick('video')">
              <div  :class="activeKey==='video'?'activeStyle':''">无线视频方案</div>
            </el-col>
            <el-col :span="6" @click="tabClick('ultrasound')">
              <div :class="activeKey==='ultrasound'?'activeStyle':''">超声方案</div>
            </el-col>
            <el-col :span="6" @click="tabClick('voice')">
              <div :class="activeKey==='voice'?'activeStyle':''">语音控制方案</div>
            </el-col>
          </el-row>
          <div class="content">
            <div class="bluetooth">
              <div v-if="activeKey==='bluetooth'" class="advantage">
                  <div class="title">蓝牙BLE智能方案的6大优势</div>
                  <el-row>
                    <el-col :span="8" v-for="(item,index) in advantageData" :key="index">
                      <div class="advantage-inner">
                        <div class="advantage-title">
                          <div>
                            {{ item.title }}
                          </div>
                        </div>
                        <div class="advantage-content">{{ item.content }}</div>
                      </div>
                    </el-col>
                  </el-row>
              </div>
              <div v-if="activeKey==='bluetooth'" class="detail">
                  <div class="title">蓝牙智能方案</div>
                  <div class="project massager">
                      <div class="introduction">
                        <div class="text">
                          <div class="p-title">腰部按摩仪</div>
                          <div class="p-desc">
                            腰部按摩仪智能化方案，提供低功耗蓝牙芯片与APP服务，可实
                            现快速开发。相比传统按摩仪的机械按键控件，本方案通过蓝牙
                            连接APP，直观地呈现模式、档位、定时与电量等功能，通过
                            手机操作和控制，使用更加便捷，同时可以使原产品体积更加小
                            巧，易于携带。
                          </div>
                        </div>
                      </div>
                      <div class="feature">
                        <div class="l-title">5大功能亮点</div>
                        <div class="module-list">
                          <div class="module-item" v-for="item in waistMassagerList" :key="item.desc">
                            <div class="text">
                              <div class="desc">
                                <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                                {{ item.desc }}
                              </div>
                              <div class="character">{{ item.character }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="interface">
                        <div class="l-title">APP参考界面</div>
                        <el-row>
                          <el-col :span="6" class="reference-app">
                            <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-loin1.png"/>
                          </el-col>
                          <el-col :span="6" class="reference-app">
                            <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-loin2.png"/>
                          </el-col>
                          <el-col :span="6" class="reference-app">
                            <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-loin3.png"/>
                          </el-col>
                          <el-col :span="6" class="reference-app">
                            <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-loin4.png"/>
                          </el-col>
                        </el-row>
                      </div>
                  </div>
                  <div class="project beauty">
                    <div class="introduction">
                        <div class="text">
                          <div class="p-title">美容仪</div>
                          <div class="p-desc" >
                            美容仪智能化方案，提供低功耗蓝牙芯片与APP服务，可实现快速开发。
                            相比传统美容仪的机械按键控件，本方案通过蓝牙将设备与手机APP连
                            接，通过手机操作和控制，直观地呈现模式、档位、定时与电量等功能，
                            使用更加便捷。在手机APP上提前设定，不仅可以定期定时提醒，并且还
                            可以衍生出一系列的功能，例如选择护肤模式，生成个人的使用历史数
                            据，记录护肤强度、频率、时长等，十分的便捷实用。
                          </div>
                        </div>
                      </div>
                    <div class="feature">
                      <div class="l-title">5大功能亮点</div>
                      <div class="module-list">
                        <div class="module-item" v-for="item in beautyList" :key="item.desc">
                          <div class="text">
                            <div class="desc">
                              <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                              {{ item.desc }}
                            </div>
                            <div class="character">{{ item.character }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="interface">
                      <div class="l-title">APP参考界面</div>
                      <el-row>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-beauty1.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-beauty2.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-beauty3.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-beauty4.png"/>
                        </el-col>
                      </el-row>
                    </div>

                  </div>
                  <div class="project humidifier">
                    <div class="introduction">
                      <div class="text">
                        <div class="p-title" >加湿器</div>
                        <div class="p-desc">
                          加湿器智能化方案，提供低功耗蓝牙芯片与APP服务，可实现快
                          速开发。相比传统加湿器的机械按键控件，本方案通过蓝牙连接
                          手机APP，直观地呈现模式、档位、定时与电量等功能，通过手
                          机操作和控制，使用更加便捷。</div>
                      </div>
                    </div>
                    <div class="feature">
                      <div class="l-title">6大功能亮点</div>
                      <div class="module-list">
                        <div class="module-item" v-for="item in humidifierList" :key="item.desc">
                          <div class="text">
                            <div class="desc">
                              <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                              {{ item.desc }}
                            </div>
                            <div class="character">{{ item.character }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="interface">
                      <div class="l-title">APP参考界面</div>
                      <el-row>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images1/solution/app-jiashi1.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images1/solution/app-jiashi2.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images1/solution/app-jiashi3.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images1/solution/app-jiashi4.png"/>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div class="project lamp">
                    <div class="introduction">
                        <div class="text">
                          <div class="p-title" >智能台灯</div>
                          <div class="p-desc" >
                            台灯智能化方案，提供低功耗蓝牙芯片与APP服务，可实现快速
                            开发。相比传统台灯的部件控制，本方案通过蓝牙将设备与手机
                            APP连接，通过手机操作和控制，直观地呈现场景、灯光亮度
                            色温与定时等功能， 通过手机操作多种照明模式，微调色温和亮
                            度，满足不同场景下的用光需求，可阅读、可会客、可冥想、可
                            伴睡。智能连接，让你的产品更符合时代发展和消费趋势。
                          </div>
                        </div>
                    </div>
                    <div class="feature">
                      <div class="l-title">5大功能亮点</div>
                      <div class="module-list">
                        <div class="module-item" v-for="item in lampList" :key="item.desc">
                          <div class="text">
                            <div class="desc">
                              <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                              {{ item.desc }}
                            </div>
                            <div class="character">{{ item.character }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="interface">
                      <div class="l-title">APP参考界面</div>
                      <el-row>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-lamp1.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-lamp2.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-lamp3.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-lamp4.png"/>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
              </div>
            </div>
            <div v-if="activeKey==='video'" class="wireless-video">
                <div class="detail">
                  <div class="title">无线视频方案</div>
                  <div class="project blackhead">
                    <div class="introduction">
                          <div class="text">
                            <div class="p-title">可视黑头仪</div>
                            <div class="p-desc">
                              增加少量成本，即可通过替换主控芯片，即可在原来的产品上增
                              加300万像素的可视功能，让用户更清楚地看到皮肤的状况。
                              黑头污垢一眼可见，针对性地进行操作，使污垢清洁更彻底。
                            </div>
                          </div>
                    </div>
                    <div class="feature">
                      <div class="l-title">4大功能亮点</div>
                      <div class="module-list">
                        <div class="module-item" v-for="item in blackheadList" :key="item.desc">
                          <div class="text">
                            <div class="desc">
                              <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                              {{ item.desc }}
                            </div>
                            <div class="character">{{ item.character }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="interface">
                      <div class="l-title">APP参考界面</div>
                      <el-row>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-blackhead1.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-blackhead2.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-blackhead3.png"/>
                        </el-col>
                        <el-col :span="6" class="reference-app">
                          <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/app-blackhead4.png"/>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            <div v-if="activeKey==='ultrasound'" class="ultrasound">
              <div class="detail">
                <div class="title">超声波方案</div>
                <div class="project cleaning">
                  <div class="introduction">
                    <div class="text">
                      <div class="p-title">茶具清洗机</div>
                      <div class="p-desc">
                        超声清洗是利用超声波在液体中的空化作用、加速作用及直进流
                        作用对附着在茶杯上污物直接、间接作用，使污物层被分散、乳
                        化、剥离而达到清洗目的。超声波由于频率高、波长短，因而传
                        播的方向性好、穿透能力强，清洗无死角。超声清洗属于物理清
                        洗，其本身为绿色清洗，若在清洗液中添加适合的清洗剂则属组
                        合清洗，更具有明显的清洗效果。
                      </div>
                    </div>
                  </div>
                  <div class="feature">
                    <div class="l-title">技术亮点</div>
                    <div class="module-list">
                      <div class="module-item" v-for="item in rinseList" :key="item.desc">
                        <div class="text">
                          <div class="desc">
                            <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                            {{ item.desc }}
                          </div>
                          <div class="character">{{ item.character }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeKey==='voice'" class="voice-control">
              <div class="detail">
                <div class="title">语音控制方案</div>
                <div class="project bin">
                  <div class="introduction">
                    <div class="text">
                      <div class="p-title">智能垃圾桶</div>
                      <div class="p-desc">智能垃圾桶搭载AI语音芯片，轻轻一声，就能唤醒垃圾桶，通过
                        语音就可以实现垃圾桶开盖、垃圾袋更换等各种事情，解放了双
                        手。智能开合，让生活更为便捷。
                      </div>
                    </div>
                  </div>
                  <div class="feature">
                    <div class="l-title">增值服务</div>
                    <div class="module-list">
                      <div class="top">
                        <div class="module-item" v-for="item in garbageList" :key="item.desc">
                          <div class="text">
                            <div class="desc">
                              <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                              {{ item.desc }}
                            </div>
                            <div class="character">{{ item.character }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="bottom">
                        <div class="module-item" v-for="item in garbageBottomList" :key="item.desc">
                          <div class="text">
                            <div class="desc">
                              <img :src="'https://website.obs.icheer.cn/icheer-web/images/resolve/'+item.img"/>
                              {{ item.desc }}
                            </div>
                            <div class="character">{{ item.character }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="interface">
                    <div class="l-title">电路样板</div>
                    <el-row>
                      <el-col :span="24" class="reference-app">
                        <img src="https://website.obs.icheer.cn/icheer-web/images/resolve/line.png"/>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
            <BrandLogoBarnerFooter  style="padding: 3px  10px 3px 3px"/>
          </div>
        </div>
    </div>
  </div>
</template>
<script setup>
import BannerDetail from './BannerDetail.vue'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import BrandLogoBarnerFooter from '@/components/BrandLogoBarnerFooter.vue'

const $router = useRouter()
const activeKey = ref('bluetooth')
const advantageData = [
  {
    title: '低成本开发',
    content: 'BLE主控替换MCU模式，省去外加蓝牙芯片，在原有BOM基础上成本增加不超过2元，如果不需要遥控器等，综合成本可能比原方案更低。'
  },
  {
    title: '产品上市周期短',
    content: '基于易客创新的成熟设备和APP交互协议，产品上市周期短。'
  },
  {
    title: '效率面板设计',
    content: '公版APP免费使用，同时，优选合作伙伴可参与APP需求和设计定义，针对不同产品特点，满足产品个性化的需求。'
  },
  {
    title: '更合理的主控方案',
    content: '完整的BLE主控选型库，覆盖碎片化产品需求。'
  },
  {
    title: '针对性的技术服务',
    content: '客户只需提供现有产品的功能定义，以及可开放的实现方法，我们负责全部软硬件设计、开发、测试。客户最小成本研发投入。'
  },
  {
    title: '高素质团队服务',
    content: '强大的研发与设计团队: 研发工程师与设计师200+;985/211名校毕业;各大名企资深工作经验，供专业、可靠、贴心的一站式服务，尽享海量优质资源。'
  }
]
// 美容仪器
const beautyList = [
  {
    desc: '蓝牙快连',
    character: '自动发现快速连接，一台设备可多用户连接。',
    img: 'icon-bluetooth.png'
  },
  {
    desc: '模式切换自由',
    character: '避免盲按的烦恼，所见即所得，切换模式更直接。',
    img: 'icon-switch.png'
  },
  {
    desc: '档位更多选择',
    character: '强度有多档可调，并可设定个人常用模式，更便捷实用。',
    img: 'icon-gear.png'
  },
  {
    desc: '调节',
    character: '可以分钟为单位设定时长，满足个体不同需求。',
    img: 'icon-switch.png'
  },
  {
    desc: '智能提醒',
    character: '在手机APP上提前设定定期提醒，避免三天打鱼、两天晒网地使用，更能保证使用效果。',
    img: 'icon-remind.png'
  }
]
// 加湿器
const humidifierList = [
  {
    desc: '蓝牙快连',
    character: '自动发现快速连接，一台设备可多用户连接。',
    img: 'icon-bluetooth.png'
  },
  {
    desc: '模式切换自由',
    character: '室内湿度和模式清晰可见，切换喷雾模式更直接。',
    img: 'icon-switch.png'
  },
  {
    desc: '档位更多选择',
    character: '更多湿度档位可调，适应性更好。',
    img: 'icon-gear.png'
  },
  {
    desc: '可定时',
    character: '支持时长自定义，满足个体不同需求。',
    img: 'icon-timing.png'
  },
  {
    desc: '调节',
    character: '如果加湿器本身带有负离子，香薰或灯光等功能，也可加上相应APP控制。',
    img: 'icon-switch.png'
  },
  {
    desc: '智能提醒',
    character: '剩余水量清晰可见。',
    img: 'icon-remind.png'
  }
]
// 智能台灯
const lampList = [
  {
    desc: '蓝牙快连',
    character: '自动发现快速连接，一台设备可多用户连接。',
    img: 'icon-bluetooth.png'
  },
  {
    desc: '模式切换自由',
    character: '场景模式清晰可见，选择场景更直观。',
    img: 'icon-switch.png'
  },
  {
    desc: '色彩更多选择',
    character: '各种颜色可选，准确度更高，适应性更好。',
    img: 'icon-gear.png'
  },
  {
    desc: '色温和亮度更多范围',
    character: '色温冷暖，亮度明暗更多可调范围。',
    img: 'icon-luminance.png'
  },
  {
    desc: '可定时',
    character: '支持自定义开关灯，满足不同需求。',
    img: 'icon-remind.png'
  }
]

// 腰部按摩仪
const waistMassagerList = [
  {
    desc: '蓝牙快连',
    character: '自动发现快速连接，一台设备可多用户连接。',
    img: 'icon-bluetooth.png'
  },
  {
    desc: '模式切换自由',
    character: '所见即所得，切换模式更直接；免去撩衣扭头找按键的尴尬。',
    img: 'icon-switch.png'
  },
  {
    desc: '色彩更多选择',
    character: '47档强度可调：挡位划分细致，适应性更好。',
    img: 'icon-gear.png'
  },
  {
    desc: '可定时',
    character: '可调1-30分钟，满足个体不同需求。',
    img: 'icon-luminance.png'
  },
  {
    desc: '智能提醒',
    character: '如果绑带松动或皮肤干燥，会提醒绑紧或滋润皮肤。',
    img: 'icon-remind.png'
  }
]
// 黑头仪
const blackheadList = [
  {
    desc: '高清成像',
    character: 'APP同步画面， 大小黑头清晰可见，精准定点吸出黑头',
    img: 'icon-hd.png'
  },
  {
    desc: 'WiFi连接',
    character: '无线连接，手机、平板均可查看，操作不受限',
    img: 'icon-WIFI.png'
  },
  {
    desc: '相册管理',
    character: '记录毛孔肌肤的状态和蜕变过程，温柔以待每一寸肌肤',
    img: 'icon-photo.png'
  },
  {
    desc: '智能提醒',
    character: '方便快捷地获取指南，免去找说明书的烦恼',
    img: 'icon-remind.png'
  }
]
// 茶具清洗机
const rinseList = [
  {
    desc: '电流反馈追频',
    character: '电流反馈追频技术匹配谐振点，减少无功功率',
    img: 'icon-electricity.png'
  },
  {
    desc: '软件实时校正',
    character: '实时追频校正谐振点，确保最高输出功率，降低热损耗，延长换能器寿命',
    img: 'icon-revise.png'
  },
  {
    desc: '过流保护',
    character: '软启动及过流保护技术，防护电流过流出现烧机问题',
    img: 'icon-burn.png'
  }
]
// 智能垃圾桶第一行
const garbageList = [
  {
    desc: '定制唤醒/命令词',
    character: '定制唤醒词',
    img: 'icon-customization.png'
  },
  {
    desc: '批量烧录',
    character: '批量烧录服务',
    img: 'icon-burn.png'
  },
  {
    desc: '测试支持',
    character: '测试支持',
    img: 'icon-test.png'
  },
  {
    desc: '方案PCBA定制',
    character: '方案PCBA定制',
    img: 'icon-scheme.png'
  }
]
// 智能垃圾桶第二行
const garbageBottomList = [
  {
    desc: 'ID设计',
    character: 'ID设计服务',
    img: 'icon-ID.png'
  },
  {
    desc: '结构设计',
    character: '结构设计服务',
    img: 'icon-structure.png'
  },
  {
    desc: '器件资源整合',
    character: '周边器件资源整合',
    img: 'icon-integration.png'
  },
  {
    desc: '电子方案设计',
    character: '全部电子解决方案设计',
    img: 'icon-design.png'
  }
]
const tabClick = (str) => {
  activeKey.value = str
}
watch(() => $router.currentRoute.value.query, (newValue, oldValue) => {
  activeKey.value = $router.currentRoute.value.query.model ? $router.currentRoute.value.query.model : 'bluetooth'
}, { immediate: true })
</script>
<style scoped>
.banner-title-hr {
  width: 100%;
  border: 1px solid #ffffff;
}

#solution>.banner, #solution {
  width: 100%;
  height: auto;
  min-width: 375px;
}

#solution>.banner{
  margin: 0 auto;
}

#solution>.banner>.mask {
  height: 10.42vw;
  width: 100%;
  position: absolute;
  top: 0;
  background-image: linear-gradient(rgba(80, 80, 80, .7), rgba(80, 80, 80, .3), rgba(80, 80, 80, 0));
}

#solution>.banner>.title1 .div1{
  margin-bottom: 0.365vw;
}

#solution>.banner>.title1 .div2{
  margin-bottom: 0.835vw;
}

#solution>.banner>.title1 .div1, .div2 {
  font-weight: 700;
  font-size: 2.6vw;
  color: #fff;
}

#solution>.banner>.title1 {
  position: absolute;
  left: 24.77vw;
  top: 7.05vw;
  width: auto;
  height: 10.42vw;
  padding: 0 0 0 0;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

#solution>.banner>.title1 .div3 {
  width: 5.94vw;
  margin-bottom: 1.4vw;
}

#solution>.banner>.title1>.div3 hr{
  width: 100%;
  border: 0.05vw solid #fff;
}

#solution>.banner>.title1 .div4{
  font-weight: 700;
  font-size: 1.56vw;
  color: #fff;
}

#solution>.main>.normal,
#solution>.main {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main{
  min-width: 375px;
  margin: 0 auto;
  padding-top: 3.62vw;
  justify-content: center;
}

#solution>.main>.normal>.menu{
  width: 42.6vw;
  height: auto;
  margin-bottom: 3vw;
}

.menu>.el-col {
  padding-left: 0.5vw;
  padding-right: 0.5vw;
}

#solution>.main>.normal>.menu>.el-col>div {
  border-radius: 0.2vw;
  height: 1.1vw;
  color: #2c3e50;
  background-color: #f6f7f9;
  font-weight: 600;
  font-size: 0.83vw;
  text-align: center;
  padding-top: 0.53vw;
  padding-bottom: 0.49vw;
}

#solution>.main>.normal>.menu>.el-col>div.activeStyle {
  color: #fff;
  background-color: #217ffb;
}

#solution>.main>.normal>.content {
  width: 42.5vw;
  height: auto;
}

#solution>.main>.normal>.content>.bluetooth{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.advantage {
  margin-bottom: 0.95vw;
}

#solution>.main>.normal>.content>.bluetooth>.advantage>.title {
  margin-bottom: 1.2vw;
}

#solution>.main>.normal>.content .title{
  text-align: center;
  font-size: 1.56vw;
  font-weight: 700;
}

#solution>.main>.normal>.content>.bluetooth>.advantage>.el-row {
  width: 42.62vw;
}

#solution>.main>.normal>.content>.bluetooth>.advantage>.el-row>.el-col {
  padding-left: 0.51vw;
  padding-right: 0.51vw;
  padding-bottom: 2.1vw;
}

.advantage-inner{
  width: 100%;
  border-radius: 0.4vw;
  height: 13vw;
  background-color: #f6f7f9;
  overflow: hidden;
  position: relative
}

.advantage-title {
  width: 100%;
  height: 32%;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/advantage-background.png);
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  text-align: center;
  padding-top: 1.1vw;
}

#solution>.main>.normal>.content>.bluetooth .advantage>.el-row .advantage-title>div {
  width: 100%;
  height: auto;
  font-weight: 700;
  font-size: 1.05vw;
}

#solution>.main>.normal>.content>.bluetooth .advantage>.el-row .advantage-content{
  color: #868686;
  padding-left: 0.9vw;
  padding-right: 0.9vw;
  height: 68%;
  line-height: 1.25vw;
  font-size: 0.7845vw;
  text-align: justify;
}

#solution>.main>.normal>.content>.bluetooth .detail{
  width: 41.6vw;
  height: auto;
}

#solution>.main>.normal>.content>.bluetooth .detail>.title{
  margin-bottom: 1.22vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager {
  margin-bottom: 1.04vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project {
  width: 100%;
  height: auto;
  background-color: #f6f7f9;
  border-radius: 0.5vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.introduction{
  width: 100%;
  height: 15.6vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/loin.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.introduction>.text{
  width: 38.5%;
  margin-left: 2.6vw;
  padding-top: 2.27vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.introduction>.text>.p-title {
  max-width: 100%;
  font-size: 1.4vw;
  color: #2c2c2d;
  margin-bottom: 1.81vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.introduction>.text>.p-desc {
  max-width: 100%;
  font-size: 0.63vw;
  letter-spacing: 0.037vw;
  word-break: break-all;
  color: #9c8f95;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature{
  width: 100%;
  height: 10.6vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature>.l-title {
  margin-bottom: 1.45vw;
}

#solution>.main>.normal>.content .l-title {
  text-align: center;
  font-size: 1.15vw;
  font-weight: 700;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .module-list {
  width: 96%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .module-item {
  display: flex;
  justify-content: center;
  width: 20%;
  height: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .text {
  width: 5.6vw;
  height: 5.6vw;
  background-color: #fff;
  box-shadow: 2px 2px 5px 2px #eeeded;
  border-radius: 0.5vw;
  display: flex;
  text-align: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .text>.desc{
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .text>.character{
  display: none;
  padding: 0 0.3vw 0 0.3vw;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: .63vw;
  line-height: 1vw;
  justify-content: center;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .text:hover>.desc {
  display: none
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.feature .text:hover>.character{
  display: flex
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.interface{
  width: 100%;
  height: 24.35vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.interface>.l-title {
  margin-bottom: 1.5vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.interface>.el-row{
  width: 38.1vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.interface .reference-app{
  border-radius: 0.55vw;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 8.9vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.massager>.interface .reference-app img{
  width: 100%;
  height: auto;
  border-radius: 0.55vw;
  object-fit: contain;
  box-shadow: 2px 2px 5px 2px #eeeded;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty{
  margin-bottom: 1.08vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.introduction {
  width: 100%;
  height: 15.6vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/beauty.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.introduction>.text{
  width: 51%;
  margin-left: 2.05vw;
  padding-top: 2.27vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.introduction>.text>.p-title {
  max-width: 100%;
  font-size: 1.4vw;
  color: #2c2c2d;
  margin-bottom: 1.5vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.introduction>.text>.p-desc{
  max-width: 100%;
  font-size: 0.63vw;
  word-break: break-all;
  color: #868686;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature {
  width: 100%;
  height: 10.6vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature>.l-title {
  margin-bottom: 1.45vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .module-list{
  width: 96%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .module-item {
  display: flex;
  justify-content: center;
  width: 20%;
  height: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .text{
  width: 5.6vw;
  height: 5.6vw;
  background-color: #fff;
  box-shadow: 2px 2px 5px 2px #eeeded;
  border-radius: 0.5vw;
  display: flex;
  text-align: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .text>.desc {
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .text>.character {
  display: none;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 0.53vw;
  line-height: 1vw;
  padding: 0 0.1vw 0 0.1vw;
  justify-content: center;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .text:hover>.desc {
  display: none
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.feature .text:hover>.character{
  display: flex
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.interface {
  width: 100%;
  height: 24.385vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.interface>.l-title{
  margin-bottom: 1.5vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.interface>.el-row{
  width: 38.1vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.interface .reference-app {
  border-radius: 0.55vw;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 8.9vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.beauty>.interface .reference-app img{
  width: 100%;
  height: auto;
  border-radius: 0.55vw;
  object-fit: contain;
  box-shadow: 2px 2px 5px 2px #eeeded;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier {
  margin-bottom: 1.05vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.introduction {
  width: 100%;
  height: 15.6vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/humidifier.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.introduction>.text{
  width: 44.5%;
  margin-left: 2.83vw;
  padding-top: 3.6vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.introduction>.text>.p-title{
  max-width: 100%;
  font-size: 1.4vw;
  color: #2c2c2d;
  margin-bottom: 2.4vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.introduction>.text>.p-desc {
  max-width: 100%;
  font-size: 0.63vw;
  word-break: break-all;
  color: #868686;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature {
  width: 100%;
  height: 10.65vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature>.l-title {
  margin-bottom: 1.45vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .module-list {
  width: 96%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .module-item{
  display: flex;
  justify-content: center;
  width: 20%;
  height: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .text>.desc{
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .text:hover>.desc {
  display: none
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .text:hover>.character{
  display: flex
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.feature .text>.character {
  display: none;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 0.63vw;
  line-height: 1vw;
  padding: 0 0.3vw 0 0.3vw;
  justify-content: center;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.interface{
  width: 100%;
  height: 24.28vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.interface>.l-title{
  margin-bottom: 1.45vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.interface>.el-row{
  width: 38vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.humidifier>.interface .reference-app{
  border-radius: 0.55vw;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 8.9vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.introduction{
  width: 100%;
  height: 15.65vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/lamp.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.introduction>.text{
  width: 44.7%;
  margin-left: 2.85vw;
  padding-top: 2.3vw;
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.introduction>.text>.p-title {
  max-width: 100%;
  font-size: 1.4vw;
  color: #fff;
  margin-bottom: 1.65vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.introduction>.text>.p-desc {
  max-width: 100%;
  font-size: 0.63vw;
  word-break: break-all;
  color: #8a9094;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature {
  width: 100%;
  height: 10.6vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature>.l-title {
  margin-bottom: 1.45vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .module-list{
  width: 96%;
  height: 100%;
  display: flex;
  flex-direction: row
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .module-item {
  display: flex;
  justify-content: center;
  width: 20%;
  height: 100%
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .text {
  width: 5.6vw;
  height: 5.6vw;
  background-color: #fff;
  box-shadow: 2px 2px 5px 2px #eeeded;
  border-radius: 0.5vw;
  display: flex;
  text-align: center
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .text>.desc{
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .text:hover>.desc{
  display: none
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .text>.character{
  display: none;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 0.63vw;
  line-height: 1vw;
  padding: 0 0.3vw 0 0.3vw;
  justify-content: center;
  align-items: center
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.feature .text:hover>.character{
  display: flex
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.interface{
  width: 100%;
  height: 24.35vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.interface>.l-title{
  margin-bottom: 1.5vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.interface>.el-row{
  width: 38.1vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.interface .reference-app{
  border-radius: 0.55vw;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 8.9vw
}

#solution>.main>.normal>.content>.bluetooth .detail>.project.lamp>.interface .reference-app img{
  width: 100%;
  height: auto;
  border-radius: 0.55vw;
  object-fit: contain;
  box-shadow: 2px 2px 5px 2px #eeeded
}

#solution>.main>.normal>.content>.wireless-video {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.wireless-video .detail{
  width: 41.6vw;
  height: auto
}

#solution>.main>.normal>.content>.wireless-video .detail>.title{
  margin-bottom: 1.22vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project {
  width: 100%;
  height: auto;
  background-color: #f6f7f9;
  border-radius: 0.5vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead {
  margin-bottom: 1.04vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.introduction{
  width: 100%;
  height: 15.6vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/blackhead.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.introduction>.text{
  width: 39%;
  margin-left: 2.6vw;
  padding-top: 2.27vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.introduction>.text>.p-title{
  max-width: 100%;
  font-size: 1.4vw;
  color: #fff;
  margin-bottom: 2.4vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.introduction>.text>.p-desc {
  max-width: 100%;
  font-size: 0.63vw;
  letter-spacing: 0.01vw;
  word-break: break-all;
  color: #fff;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature{
  width: 100%;
  height: 10.6vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature>.l-title{
  margin-bottom: 1.45vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .module-list{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .module-item {
  display: flex;
  justify-content: center;
  width: 25%;
  height: 100%
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .text{
  width: 5.6vw;
  height: 5.6vw;
  background-color: #fff;
  box-shadow: 2px 2px 5px 2px #eeeded;
  border-radius: 0.5vw;
  display: flex;
  text-align: center
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .text>.desc {
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .text:hover>.desc {
  display: none
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .text>.character {
  display: none;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 0.63vw;
  line-height: 1vw;
  padding: 0 0.3vw 0 0.3vw;
  justify-content: center;
  align-items: center
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.feature .text:hover>.character {
  display: flex
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.interface {
  width: 100%;
  height: 24.35vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.interface>.l-title{
  margin-bottom: 1.5vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.interface>.el-row {
  width: 37.8vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.interface .reference-app {
  border-radius: 0.55vw;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 8.9vw
}

#solution>.main>.normal>.content>.wireless-video .detail>.project.blackhead>.interface .reference-app img{
  width: 100%;
  height: auto;
  border-radius: 0.55vw;
  object-fit: contain;
  box-shadow: 2px 2px 5px 2px #eeeded
}

#solution>.main>.normal>.content>.ultrasound{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.ultrasound .detail{
  width: 41.6vw;
  height: auto
}

#solution>.main>.normal>.content>.ultrasound .detail>.title{
  margin-bottom: 1.22vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project{
  width: 100%;
  height: auto;
  background-color: #f6f7f9;
  border-radius: 0.5vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning{
  margin-bottom: 1.04vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.introduction{
  width: 100%;
  height: 15.6vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/ultrasound.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.introduction>.text{
  width: 38.5%;
  margin-left: 2.6vw;
  padding-top: 2.27vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.introduction>.text>.p-title{
  max-width: 100%;
  font-size: 1.4vw;
  color: #fff;
  margin-bottom: 1.05vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.introduction>.text>.p-desc {
  max-width: 100%;
  font-size: 0.63vw;
  word-break: break-all;
  color: #f1f1f1;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature{
  width: 100%;
  height: 10vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature>.l-title{
  margin-bottom: 1.45vw
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .module-list{
  width: 111%;
  height: 100%;
  display: flex;
  flex-direction: row
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .module-item{
  display: flex;
  justify-content: center;
  width: 33.33%;
  height: 100%
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .text{
  width: 5.6vw;
  height: 5.6vw;
  background-color: #fff;
  box-shadow: 2px 2px 5px 2px #eeeded;
  border-radius: 0.5vw;
  display: flex;
  text-align: center
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .text>.desc{
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .text:hover>.desc{
  display: none
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .text>.character{
  display: none;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 0.63vw;
  line-height: 1vw;
  padding: 0 0.3vw 0 0.3vw;
  justify-content: center;
  align-items: center
}

#solution>.main>.normal>.content>.ultrasound .detail>.project.cleaning>.feature .text:hover>.character{
  display: flex
}

#solution>.main>.normal>.content>.voice-control {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.voice-control .detail {
  width: 41.6vw;
  height: auto
}

#solution>.main>.normal>.content>.voice-control .detail>.title{
  margin-bottom: 1.22vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project {
  width: 100%;
  height: auto;
  background-color: #f6f7f9;
  border-radius: 0.5vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin{
  margin-bottom: 1.04vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.introduction {
  width: 100%;
  height: 15.6vw;
  margin-bottom: 2.25vw;
  border-radius: 0.5vw;
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/solution/bin.jpg);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.introduction>.text{
  width: 38.5%;
  margin-left: 2.6vw;
  padding-top: 2.27vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.introduction>.text>.p-title {
  max-width: 100%;
  font-size: 1.4vw;
  color: #2c2c2d;
  margin-bottom: 3vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.introduction>.text>.p-desc{
  max-width: 100%;
  font-size: 0.63vw;
  letter-spacing: 0.02vw;
  word-break: break-all;
  color: #868686;
  font-family: HarmonyOS_Sans_SC_Regular;
  line-height: 1.25vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature{
  width: 100%;
  height: 17.05vw;
  display: flex;
  flex-direction: column;
  align-items: center
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature>.l-title{
  margin-bottom: 1.45vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .module-list{
  width: 102%;
  height: 100%;
  display: flex;
  flex-direction: column
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .module-list>.top,.bottom{
  width: 100%;
  height: 45%;
  display: flex;
  flex-direction: row
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .module-item{
  display: flex;
  justify-content: center;
  width: 25%;
  height: 100%
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .text{
  width: 5.6vw;
  height: 5.6vw;
  background-color: #fff;
  box-shadow: 2px 2px 5px 2px #eeeded;
  border-radius: 0.5vw;
  display: flex;
  text-align: center
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .text>.desc{
  width: 100%;
  height: 100%;
  font-size: 0.67vw;
  letter-spacing: -0.07vw;
  margin: 1vw auto;
  display: flex;
  flex-direction: column;
  text-align: center
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .text:hover>.desc{
  display: none
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .text>.desc img{
  margin: 0 auto 0.6vw auto;
  display: flex;
  object-fit: contain;
  width: 45%
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .text>.character{
  display: none;
  width: 100%;
  height: 100%;
  background-color: #207ffa;
  border-radius: 0.5vw;
  color: #fff;
  font-size: 0.63vw;
  line-height: 1vw;
  padding: 0 0.3vw 0 0.3vw;
  justify-content: center;
  align-items: center
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.feature .text:hover>.character{
  display: flex
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.interface{
  width: 100%;
  height: 24.35vw;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.interface>.l-title{
  margin-bottom: 1.5vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.interface>.el-row{
  width: 41.65vw;
  position: absolute;
  top: -0.4vw
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.interface .reference-app{
  border-radius: 0.55vw;
  display: flex;
  flex-direction: column;
  margin: auto
}

#solution>.main>.normal>.content>.voice-control .detail>.project.bin>.interface .reference-app img{
  width: 41.65vw;
  height: auto;
  border-radius: 0.55vw;
  object-fit: contain
}
</style>
